import scheduleReducer from './reducers';

export { default as scheduleActions } from './actions';
export { default as scheduleOperations } from './operations';
//export { default as dashboardShapes } from './shapes';

export default scheduleReducer;
